// flowgenIgnore
import React, { ComponentProps, ReactElement } from 'react';
import { I18n as I18nType } from '@lingui/core';
import { I18n, I18nProvider as LegacyI18nProvider } from '@lingui/react';

import { getDateTimeFormatMapForLang } from '@rover/shared/js/constants/i18n/datetime';

export type DateTimeFormatType = ReturnType<typeof getDateTimeFormatMapForLang>;

export type I18nContextType = {
  i18n: I18nType;
  datetimeFormatMap: DateTimeFormatType;
};

export const I18nContext = React.createContext<I18nContextType | null | undefined>(undefined);

export type I18nProviderPropType = ComponentProps<typeof LegacyI18nProvider>;

export function I18nProvider({ children, ...i18nConfig }: I18nProviderPropType): ReactElement {
  return (
    <LegacyI18nProvider {...i18nConfig}>
      <I18n>
        {({ i18n }) => {
          const datetimeFormatMap = getDateTimeFormatMapForLang(i18n.language);
          return (
            <I18nContext.Provider
              value={{
                i18n,
                datetimeFormatMap,
              }}
            >
              {children}
            </I18nContext.Provider>
          );
        }}
      </I18n>
    </LegacyI18nProvider>
  );
}

type I18nHookValue = {
  i18n: I18nType;
  locale: string;
  DF: DateTimeFormatType;
};

export function useI18n(): I18nHookValue {
  const i18nContext = React.useContext(I18nContext);
  if (!i18nContext) throw new Error(`I18nProvider is not setup properly`);
  const { i18n, datetimeFormatMap } = i18nContext;
  return {
    i18n,
    locale: i18n.language,
    DF: datetimeFormatMap,
  };
}
export type { I18nType };



// WEBPACK FOOTER //
// ../react-lib/src/utils/i18n.tsx